var __rspack_ns_object = JSON.parse('{"errorList":[{"parameter":"","code":"","message":"Login error message"}]}')